import { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, NavLink } from 'reactstrap';
import MenuItem from '../MenuItem/MenuItem';
import { MultiLevelDropdownWrapper } from './MultiLevelDropdown.styled';

const menuData = [
   {
      label: "Getting Started",
      href: "/getting-started"
   },
   {
      label: "Java Basics",
      href: "/java-basics",
      children: [
         { label: "Programming Language", href: "/programming-language" },
         { label: "Data Types", href: "/data-types" },
         { label: "Keywords & Variables", href: "/keywords-variables" },
         { label: "Recursion", href: "/recursion" },
         { label: "Runtime Linking", href: "/runtime-linking" },
      ]
   },
   {
      label: "Control Statements",
      href: "/control-statements",
      children: [
         { label: "If Else & Switch", href: "/if-else-switch" },
         { label: "Loops", href: "/loops" },
         { label: "Break & Continue Keywords", href: "/break-continue-keywords" }
      ]
   },
   {
      label: "OOPS Concepts",
      href: "/oops-concepts",
      children: [
         { label: "Classes & Objects", href: "/classes-objects"},
         { label: "Access Modifier", href: "/access-modifier"},
         { label: "4 Pillars of OOPS", href: "/4-pillars-of-oops"},
         { label: "Constructors & Destructors", href: "/constructors-destructors"},
         { label: "Initializer Block", href: "/initializer-block"},
         { label: "Static, this, super & final Keyword", href: "/static-this-super-final-keyword"}
      ]
   },
   {
      label: "Core Java",
      href: "/core-java",
      children: [
         { label: "Java Environment", href: "/java-environment"},
         { label: "Strings", href: "/strings"},
         { label: "Arrays", href: "/arrays"},
         { 
            label: "Collections", 
            href: "/collections",
            children: [
               { label: "List", href: "/list"},
               { label: "Queue", href: "/queue"},
               { label: "Set", href: "/set"},
               { label: "Map", href: "/map"},
               { label: "Concurrent Collection", href: "/concurrent-collection"},
            ]
         },
         { label: "Exception Handling", href: "/exception-handling"},
         { label: "Multi Threading", href: "/multi-threading"},
         { 
            label: "Wrapper Class", 
            href: "/wrapper-class",
            children:[
               { label: "Autoboxing & Unboxing", href: "/autoboxing-unboxing"},
               { label: "Type Casting", href: "/type-casting"}
            ]
         },
         { label: "Interface & Abstract Class", href: "/interface-abstract-class"}
      ]
   },
   {
      label: "Advanced Java",
      href: "/advanced-java",
      children: [
         { label: "Synchronization", href:"/synchronization" },
         { label: "Serialization & Deserialization", href:"/serialization-deserialization" },
         { label: "JDBC", href: "/jdbc" },
         {
            label: "Servlet",
            href: "/servlet",
            children: [
               { label: "Working of a Servlet", href: "/working-of-a-servlet" },
               { label: "Session Management", href: "/session-management" },
            ]
         },
         { label: "JSP", href: "/jsp" },
         { label: "Try with Resources", href: "/try-with-resources" }
      ]
   },
   {
      label: "Java 8 Features",
      href: "/java-8-features",
      children: [
         { label: "For each Loop", href: "/for-each-loop"},
         { label: "Lambda Expressions", href: "/lambda-expressions"},
         { label: "Optional Class", href: "/optional-class"},
         { label: "Functional Interface", href: "/functional-interface"},
         { label: "String Builder, Buffer & Tokenizer", href:"/string-builder-buffer-tokenizer"},
         { label: "Stream API", href: "/stream-api"}
      ]
   },
   {
      label: "Spring Framework",
      href: "/spring-framework",
      children: [
         { label: "Spring MVC", href: "/spring-mvc"},
         { label: "Spring Boot", href: "/spring-boot"}
      ]
   },
   {
      label: "REST Web Services",
      href: "/rest-web-services",
   },
   {
      label: "Dynamic Programming",
      href: "/dynamic-programming",
      children: [
         { label: "What is Dynamic Programming?", href: "/what-is-dp"},
         { label: "Types of DP", href: "/types-of-dp"},
         { label: "Linear DP", href: "/linear-dp"},
         { label: "Kadane's Algorithm", href: "/kadane-algorithm"},
         { label: "0/1 Knapsack", href: "/01-knapsack"},
         { label: "Unbounded Knapsack", href: "/unbounded-knapsack"},
         { label: "Subsequence", href: "/subsequence"}
      ]
   }
];


const MultiLevelDropdown = () => {

   const [dropdownOpen, setDropdownOpen] = useState(false);

   return (
      <MultiLevelDropdownWrapper>
         <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
            <div className="multi-dropdown" style={{ display: 'flex', justifyContent: "flex-end" }}>
               <NavLink href="/lets-get-started"  style={{ paddingRight: 0 }}>Let's get started!</NavLink>
               <DropdownToggle nav caret style={{ paddingLeft: '0rem', fontSize: 'x-large', paddingTop: '0.2rem' }}></DropdownToggle>
            </div>
            <DropdownMenu>
               {menuData.map((item, i) => (
                  <>
                     <MenuItem key={i} {...item} />
                     {menuData.length !== i+1 && <DropdownItem divider />}
                  </>
               ))}
            </DropdownMenu>
         </Dropdown>
      </MultiLevelDropdownWrapper>
   );
}

export default MultiLevelDropdown;